import { Spin, Row } from "antd";
import styled from "styled-components";
import React from "react";
import I18n from "../../i18n";
import { Colors } from "../../theme";

const PersistGateLoading = (props) => (
	<Row align='middle' justify='center' type='flex' style={{...props.style, height: "100vh" }}>
		<Spin />
	</Row>
);
const UnlimitSpinner = styled(Spin)`
    max-height:inherit !important;
`;
export const PreloadDiv = styled.div`
    width:${props=>props.width ? props.width : 100}px;
    height:${props=>props.height ? props.height : 100}px;
`;
export const ContainerLoading = ({isLoading, children, loadingChildren, tip, style, size="large", empty = false})=>{
	const spinnerStyle={
		backgroundColor:Colors.loading.backgroundColor,
	};
	if(isLoading){
		return (<UnlimitSpinner style={{...style, ...spinnerStyle}}
			tip={tip || I18n.t("loading")} 
			size={size}>
			{ loadingChildren !== undefined ? loadingChildren : children}
		</UnlimitSpinner>);
	}
	if(empty){
		return <React.Fragment>{children}</React.Fragment>;
	}
	return <div style={style}>{children}</div>;
};
export default PersistGateLoading;


// WEBPACK FOOTER //
// ./src/components/loading/PersistGateLoading.js